import { PickedMonthDate } from "../components/energyusage/types/ChartTypes";

export const getKey = (mpan: string, date: PickedMonthDate): string => {
  const key = mpan + '_' + date.begin + date.end;
  return key;
};
